module.exports = __webpack_public_path__ + "img/tally-ho.276c975b.jpg";